import { SPSELECTS } from "InterfacesTypes/enums";
import type { IHowToImage } from "InterfacesTypes/interfaces";
import type { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { fetchFailure, fetchHowToImages, fetchStart, fetchSuccess } from "state/reducers/HowToImagesReducer";
import { spGet } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";

const env = getEnvironment();
function* getHowToImagesWorker(): SagaIterator {
    try {
        yield put(fetchStart());
        const howTosUrl = `${env.listapi}/GetByTitle('HowToImages')/Items?$top=5000&$select=${SPSELECTS.HOWTOIMAGES}`;
        const data: IHowToImage[] = yield call(spGet, howTosUrl);
        yield put(fetchSuccess(data));
    } catch (err: any) {
        yield put(fetchFailure(err?.message ?? "Något gick fel i howToImages sagan"));
    }
}

export function* howToImagesSaga() {
    yield takeLatest(
        fetchHowToImages.type,
        getHowToImagesWorker
    )
}